module.exports = __webpack_public_path__ + "img/code1.5d3d7bc7.jpg";